// Re-export the new modular LandingPage component
export { default } from './LandingPage';
